<script context="module">
    import { writable } from 'svelte/store';

    const defaultVenta = () => ({
        cliente: '',
        fecha: new Date(),
    });

    export const TIPOS = {
        PUBLICO: 'publico',
        CASA: 'casa',
        FAMILIA: 'familia',
    };

    export const datosVenta = writable(defaultVenta());
    export const tipo = writable(TIPOS.PUBLICO);
    export const cantidadPorProducto = writable({});
    export const precioPorProducto = writable({});
    export function resetearVenta() {
        cantidadPorProducto.set({});
        datosVenta.set(defaultVenta());
    }
</script>
